// extracted by mini-css-extract-plugin
export var container = "_69-0";
export var icon = "_69-1";
export var text = "_69-2";